const getMatchedIndices = (text: string, matchedValue: string) => {
  const lowerText = text.toLocaleLowerCase();
  const lowerMatchedValue = matchedValue.toLocaleLowerCase();
  const startIndex = lowerText.indexOf(lowerMatchedValue);

  if (startIndex === -1) return null;

  return {
    startIndex,
    endIndex: startIndex + matchedValue.length,
  };
};

export const mapDynamicMessage = (
  message: string,
  matchs: Record<string, string>,
) => {
  return Object.entries(matchs).reduce((acc, [key, value]) => {
    return acc.replaceAll(`{{${key}}}`, value);
  }, message);
};

const textUtils = {
  getMatchedIndices,
};

export default textUtils;
